import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        // location check in
        {
            path: '/loginCompaniesList',
            name: 'loginCompaniesListRoute',
            component: () => import('@/components/loginCompaniesList.vue')
        },

        // location check in
        {
            path: '/locationCheckIn/:locationId/:language?',
            name: 'locationCheckInRoute',
            component: () => import('@/components/locationCheckInPage.vue'),
            props: true,
        },

        // registerCompany
        {
            path: '/imageViewer/:ID?/:eventID?/:from?/:showPrev?/:showNext?',
            name: 'imageViewer',
            component: () => import('@/components/misc/imageViewer.vue'),
            props: true
        },

        // registerCompany
        {
            path: '/registerCompany/:language?',
            name: 'registerCompanyRoute',
            component: () => import('@/components/registerCompany.vue'),
            props: true
        },

        // login
        {
            path: '/login/:language?',
            name: 'loginRoute',
            component: () => import('@/components/login.vue'),
            props: true
        },

        //logOut
        {
            path: '/logout',
            name: 'logOutRoute',
            component: () => import('@/components/logOut.vue'),
        },

        // LOGIN RFID page
        {
            path: '/loginRfid/:language?',
            name: 'loginRfid',
            component: () => import('@/components/loginRfid.vue'),
            props: true
        },

        // dashboard RFID with events
        {
            path: '/dashboardRfid/:accessToken/:rfidTag/:language?',
            name: 'dashboardRfid',
            component: () => import('@/components/dashboardRfid.vue'),
            props: true
        },

        // efactura
        {
            path: '/indexEfactura',
            name: 'indexEfacturaRoute',
            component: () => import('@/components/efactura/indexEfactura.vue'),
            children: [
                {
                    path: '/mainEfactura/:language?',
                    name: 'mainEfacturaRoute',
                    component: () => import('@/components/efactura/mainEfactura.vue'),
                    props: true
                },
                {
                    path: '/companyEfactura/:language?',
                    name: 'companyEfacturaRoute',
                    component: () => import('@/components/efactura/efacturaSpv/companyEfactura.vue'),
                    props: true
                },
                {
                    path: '/billingEfactura/:clientIds?/:seriesIds?/:createdIds?/:page?',
                    name: 'billingEfacturaRoute',
                    component: () => import('@/components/efactura/billing/billingEfactura.vue'),
                    props: true
                },
                {
                    path: '/clientsEfactura/:page?',
                    name: 'clientsEfacturaRoute',
                    component: () => import('@/components/efactura/clients/clientsEfactura.vue'),
                    props: true
                },
                {
                    path: '/articlesEfactura/:page?',
                    name: 'articlesEfacturaRoute',
                    component: () => import('@/components/efactura/articles/articlesEfactura.vue'),
                    props: true
                },
                {
                    path: '/categoriesEfactura/:page?',
                    name: 'categoriesEfacturaRoute',
                    component: () => import('@/components/efactura/articleCategories/categoriesEfactura.vue'),
                    props: true
                },
                {
                    path: '/efacturaSettings/:subTab?',
                    name: 'efacturaSettingsRoute',
                    component: () => import('@/components/efactura/settings/efacturaSettings.vue'),
                    props: true
                },
                {
                    path: '/companyEfactura/messagesCompanyEfactura/:spvCompanyId?/:page?',
                    name: 'messagesCompanyEfacturaRoute',
                    component: () => import('@/components/efactura/efacturaSpv/messagesCompanyEfactura.vue'),
                    props: true
                },
                {
                    path: '/loginEfactura/:language?',
                    name: 'loginEfacturaRoute',
                    component: () => import('@/components/efactura/loginEfactura.vue'),
                    props: true
                },
                {
                    path: '/logOutEfactura/:language?',
                    name: 'logOutEfacturaRoute',
                    component: () => import('@/components/efactura/logOutEfactura.vue'),
                    props: true
                },
                {
                    path: '/registerCompanyEfactura/:language?',
                    name: 'registerCompanyEfacturaRoute',
                    component: () => import('@/components/efactura/registerCompanyEfactura.vue'),
                    props: true
                },
                {
                    path: '/passwordRecoverEfactura/:language?',
                    name: 'passwordRecoverEfacturaRoute',
                    component: () => import('@/components/efactura/passwordRecoverEfactura.vue'),
                    props: true
                },
            ]
        },

        // loginMultiuser
        {
            path: '/loginMultiUser/:language?/:sessionToken?/:sessionCompanyId?/:prevUrl?',
            name: 'loginMultiUserRoute',
            component: () => import('@/components/loginMultiUser.vue'),
            props: true
        },

        // login
        {
            path: '/requestInformation/:uid?', // :language is used in main.js to setCompanyLanguage so we can translate this page
            name: 'requestInformationRoute',
            component: () =>  import('@/components/user/userRequestInformation.vue'),
            props: true
        },

        // password recover
        {
            path: '/recover/:language?',
            name: 'passwordRecoverRoute',
            component: () => import('@/components/passwordRecover.vue'),
            props: true
        },

        // password reset
        {
            path: '/reset/:password_recovery_key/:language?',
            name: 'passwordResetRoute',
            component: () => import('@/components/passwordReset.vue'),
            props: true
        },

        {
            path: '/activity',
            name: 'activityRoute',
            component: () => import('@/components/activity.vue'),
            children: [
                {
                    path: 'eventDetails/:eventId/:companyId?',
                    name: 'eventDetailsRoute',
                    component: () => import('@/components/activity/eventDetails.vue'),
                    props: true
                },
                {
                    path: ':page?/:users?/:teams?/:eventTypes?/:status?/:dateInterval?/:reason?/:hoursInterval?',
                    name: 'activityEventsRoute',
                    component: () => import('@/components/activity/index.vue'),
                    props: true
                },
            ]
        },

        {
            path: '/dashboard/:teams?/:month?/:year?',
            name: 'dashboardRoute',
            component: () => import('@/components/dashboard.vue'),
            props: true
        },

        {
            path: '/privacyPolicy/:uid?/:documentID?',
            name: 'privacyPolicyRoute',
            component: () => import('@/components/settings/privacyPolicy.vue'),
            props: true
        },

        {
            path: '/document/:id?/:operation?',
            name: 'documentRoute',
            component: () => import('@/components/documents/document.vue'),
            props: true
        },

        {
            path: '/fileViewer/:documentID?/:fileID?',
            name: 'fileViewerRoute',
            component: () => import('@/components/misc/fileViewNewWindow.vue'),
            props: true
        },

        {
            path: '/user/:userId',
            component: () => import('@/components/user.vue'),
            props: true,
            children: [
                {
                    path: 'customFields',
                    name: 'customFieldsRoute',
                    component: () => import('@/components/user/customFields.vue'),
                    props: true
                },
                {
                    path: 'reviews/:selectedTab?',
                    name: 'reviewsRoute',
                    component: () => import('@/components/user/reviews.vue'),
                    props: true
                },
                {
                    path: 'documents/:subTab?/:folderID?/:sortItem?/:sortOrder?/:currentPage?',
                    name: 'documentsRoute',
                    component: () => import('@/components/user/documents.vue'),
                    props: true
                },
                {
                    path: 'dayData/:page?/:month?/:year?/:day?',
                    name: 'userDayDataRoute',
                    component: () => import('@/components/user/dayData.vue'),
                    props: true
                },
                {
                    path: 'attendance/:page?/:dateInterval?',
                    name: 'userAttendanceRoute',
                    component: () => import('@/components/user/attendance.vue'),
                    props: true
                },
                {
                    path: 'settings',
                    component: () => import('@/components/user/userSettings.vue'),
                    props: true,
                    children: [
                        {
                            path: 'accountSettings',
                            name: 'subTabAccountSettingsRoute',
                            component: () => import('@/components/user/userSettings/subTabAccountSettings.vue'),
                            props: true
                        },
                        {
                            path: 'contracts',
                            name: 'subTabContractsRoute',
                            component: () => import('@/components/user/userSettings/subTabContracts.vue'),
                            props: true
                        },
                        {
                            path: 'permissions',
                            name: 'subTabPermissionsRoute',
                            component: () => import('@/components/user/userSettings/subTabPermissions.vue'),
                            props: true
                        },
                        {
                            path: 'rfid',
                            name: 'subTabRfidRoute',
                            component: () => import('@/components/user/userSettings/subTabRfid.vue'),
                            props: true
                        },
                        {
                            path: '',
                            name: 'subTabPersonalDataRoute',
                            component: () => import('@/components/user/userSettings/subTabPersonalData.vue'),
                            props: true
                        },
                    ]
                },
                {
                    path: '',
                    name: 'userProfileRoute',
                    component: () => import('@/components/user/userProfile.vue'),
                    props: true
                },

            ]
        },

        {
            path: '/superadmin',
            name: 'superAdminRoute',
            component: () => import('@/components/superAdmin.vue'),
            children: [
                {
                    path: 'templates',
                    component: () => import('@/components/superAdmin/documentTemplates.vue'),
                    children: [
                        {
                            path: '',
                            name: 'superDocumentTemplatesRoute',
                            component: () => import('@/components/superAdmin/documentTemplates/templatesList.vue')
                        },
                        {
                            path: 'add',
                            name: 'superAddDocumentTemplateRoute',
                            component: () => import('@/components/superAdmin/documentTemplates/addTemplate.vue'),
                        },
                        {
                            path: 'edit/:template_id',
                            name: 'superEditDocumentTemplateRoute',
                            component: () => import('@/components/superAdmin/documentTemplates/editTemplate.vue'),
                            props: true
                        }
                    ]
                },
                {
                    path: 'freeDays',
                    component: () => import('@/components/superAdmin/globalFreeDays.vue'),
                    children: [
                        {
                            path: '',
                            name: 'globalFreeDaysRoute',
                            component: () => import('@/components/superAdmin/globalFreeDays/list.vue')
                        },
                        {
                            path: 'edit/:day_id',
                            name: 'addEditFreeDayRoute',
                            component: () => import('@/components/superAdmin/globalFreeDays/add_edit.vue'),
                            props: true
                        }
                    ]
                },
                {
                    path: 'emailTesting',
                    name: 'emailTestingRoute',
                    component: () => import('@/components/superAdmin/emailTesting.vue'),
                },
                {
                    path: 'syncArticles',
                    name: 'syncArticlesRoute',
                    component: () => import('@/components/superAdmin/syncArticles.vue'),
                },
                {
                    path: 'tracking',
                    name: 'trackingRoute',
                    component: () => import('@/components/superAdmin/tracking.vue'),
                },
                {
                    path: 'trackingDetails/:companyId',
                    name: 'trackingDetailsRoute',
                    component: () => import('@/components/superAdmin/trackingDetails.vue'),
                    props: true
                },
                {
                    path: 'billing',
                    name: 'billing',
                    component: () => import('@/components/superAdmin/billing.vue'),
                    children: [
                        {
                            path: 'subscriptions/:companyName?',
                            name: 'subscriptions',
                            component: () => import('@/components/superAdmin/billing/subs.vue'),
                            props: true
                        },
                        {
                            path: 'invoices/:companyName?',
                            name: 'invoices',
                            component: () => import('@/components/superAdmin/billing/invoices.vue'),
                            props: true
                        },
                    ]
                },
                {
                    path: 'apiLog/:page?/:mmodule?/:endpoint?/:company?/:user?/:rfid_tag?',
                    name: 'apiLogRoute',
                    component: () => import('@/components/superAdmin/apiLog.vue'),
                    props: true
                },
                {
                    path: 'companiesList/:listType',
                    name: 'companiesListRoute',
                    component: () => import('@/components/superAdmin/companiesList.vue'),
                    props: true
                },
                {
                    path: 'listaFirmeRedirect/:companyName',
                    name: 'listaFirmeRedirectRoute',
                    component: () => import('@/components/superAdmin/listaFirmeRedirect.vue'),
                    props: true
                },
                {
                    path: 'companiesAndUsersList',
                    name: 'companiesAndUsersListRoute',
                    component: () => import('@/components/superAdmin/companiesAndUsersList.vue'),
                },
                {
                    path: 'adminsActiveDisabledList',
                    name: 'adminsActiveDisabledListRoute',
                    component: () => import('@/components/superAdmin/adminsActiveDisabledList.vue'),
                },
                {
                    path: 'addEventTypesOnAlertSettings',
                    name: 'addEventTypesOnAlertSettingsRoute',
                    component: () => import('@/components/superAdmin/addEventTypesOnAlertSettings.vue'),
                },
                {
                    path: 'addDaysOnLeaveDaysTypes',
                    name: 'addDaysOnLeaveDaysTypesRoute',
                    component: () => import('@/components/superAdmin/addDaysOnLeaveDaysTypes.vue'),
                },
                {
                    path: 'addWorkScheduleDefaultLocation',
                    name: 'addWorkScheduleDefaultLocationRoute',
                    component: () => import('@/components/superAdmin/addWorkScheduleDefaultLocation.vue'),
                },
                {
                    path: 'companiesDuplicateUsers',
                    name: 'companiesDuplicateUsersRoute',
                    component: () => import('@/components/superAdmin/companiesDuplicateUsers.vue'),
                },
                {
                    path: 'companiesGroups',
                    name: 'companiesGroupsRoute',
                    component: () => import('@/components/superAdmin/companiesGroups.vue'),
                },
                {
                    path: 'importCsv',
                    name: 'importCsvRoute',
                    component: () => import('@/components/superAdmin/importCsv.vue'),
                },
                {
                    path: 'testApi',
                    name: 'testApiRoute',
                    component: () => import('@/components/superAdmin/testApi.vue'),
                },
                {
                    path: 'billingV2/:subTab?',
                    name: 'billingV2Route',
                    component: () => import('@/components/superAdmin/billingV2.vue'),
                    props: true
                },
                {
                    path: 'addDefaultLocation',
                    name: 'addDefaultLocationRoute',
                    component: () => import('@/components/superAdmin/addDefaultLocation.vue'),
                },
                {
                    path: 'contactReport',
                    name: 'contactReportRoute',
                    component: () => import('@/components/superAdmin/contactReport.vue'),
                },
                {
                    path: 'salesReport',
                    name: 'salesReportRoute',
                    component: () => import('@/components/superAdmin/salesReport.vue'),
                },
                {
                    path: 'revenueReport',
                    name: 'revenueReportRoute',
                    component: () => import('@/components/superAdmin/revenueReport.vue'),
                },
                {
                    path: 'addUserLocation',
                    name: 'addUserLocationRoute',
                    component: () => import('@/components/superAdmin/addUserLocation.vue'),
                },
                {
                    path: 'addRfidLocation',
                    name: 'addRfidLocationRoute',
                    component: () => import('@/components/superAdmin/addRfidLocation.vue'),
                },
                {
                    path: 'addCompanyOtherLeaveDaysTypes',
                    name: 'addCompanyOtherLeaveDaysTypesRoute',
                    component: () => import('@/components/superAdmin/addCompanyOtherLeaveDaysTypes.vue'),
                },
                {
                    path: 'disableCompanies',
                    name: 'disableCompaniesRoute',
                    component: () => import('@/components/superAdmin/disableCompanies.vue'),
                },
                {
                    path: 'dataModification',
                    name: 'dataModificationRoute',
                    component: () => import('@/components/superAdmin/dataModification.vue'),
                },
                {
                    path: 'addHalfDayPaidLeave',
                    name: 'addHalfDayPaidLeaveRoute',
                    component: () => import('@/components/superAdmin/addHalfDayPaidLeave.vue'),
                },
                {
                    path: 'addCompanyFreeDays',
                    name: 'addCompanyFreeDaysRoute',
                    component: () => import('@/components/superAdmin/addCompanyFreeDays.vue'),
                },
                {
                    path: 'liveAttendanceToIntervals',
                    name: 'liveAttendanceToIntervalsRoute',
                    component: () => import('@/components/superAdmin/liveAttendanceToIntervals.vue'),
                },
                {
                    path: 'addCovid',
                    name: 'addCovidRoute',
                    component: () => import('@/components/superAdmin/addCovid.vue'),
                },
                {
                    path: 'moveUnlockCheckInOutDatetime',
                    name: 'moveUnlockCheckInOutDatetimeRoute',
                    component: () => import('@/components/superAdmin/moveUnlockCheckInOutDatetime.vue'),
                },
                {
                    path: 'cronJobs',
                    component: () => import('@/components/superAdmin/cronJobs.vue'),
                    children: [
                        {
                            path: '',
                            name: 'globalCronJobsRoute',
                            component: () => import('@/components/superAdmin/cronJobs/list.vue')
                        },
                        {
                            path: 'log/:page',
                            name: 'cronJobsLogRoute',
                            component: () => import('@/components/superAdmin/cronJobs/log.vue'),
                            props: true
                        }
                    ]
                },
                {
                    path: 'customerReports',
                    name: 'customerReportsRoute',
                    component: () => import('@/components/superAdmin/customerReports.vue')
                },
                {
                    path: 'debugTeamsDepartments',
                    name: 'debugTeamsDepartmentsRoute',
                    component: () => import('@/components/superAdmin/debugTeamsDepartments.vue')
                },
                {
                    path: 'linkedAccounts',
                    name: 'linkedAccountsRoute',
                    component: () => import('@/components/superAdmin/linkedAccounts.vue')
                },
                {
                    path: 'companiesMessages',
                    name: 'companiesMessagesRoute',
                    component: () => import('@/components/superAdmin/companiesMessages.vue')
                },
            ]
        },

        {
            path: '/usersManagerActive/:user?/:teamIds?/:selectedUsers?/:operation?',
            component: () => import('@/components/usersManager/users.vue'),
            name: 'usersIndex',
            props: true,
        },

        {
            path: '/general_documents',
            component: () => import('@/components/generalDocuments/generalDocuments.vue'),
            children: [
                {
                    path: 'documents/:sortItem?/:sortOrder?/:currentPage?/:showResults?/:isArchived?/:ownerIDs?/:ownerTeamIDs?/:createdByIDs?/:signeeIDs?/:documentStatus?/:otherFilterIDs?/:folderIDs?/:seriesIDs?/:eventTypeIDs?/:leaveDaysTypeIDs?/:templateIDs?/:dateIntervalStart?/:dateIntervalEnd?/:searchText?',
                    name: 'generalDocumentsRoute',
                    component: () => import('@/components/generalDocuments/generalDocumentsList.vue'),
                    props: true,
                }
            ]
        },

        {
            path: '/general_reminders',
            component: () => import('@/components/generalReminders/generalReminders.vue'),
            children: [
                {
                    path: 'reminders/:sortItem?/:sortOrder?/:currentPage?/:showResults?/:isFinalized?/:emailSentSelected?/:sendEmailSelected?/:ownerIDs?/:ownerTeamIDs?/:createdByIDs?/:eventTypeIDs?/:leaveDaysTypeIDs?/:dueDateIntervalStart?/:dueDateIntervalEnd?/:reminderDateIntervalStart?/:reminderDateIntervalEnd?',
                    name: 'generalRemindersRoute',
                    component: () => import('@/components/generalReminders/generalRemindersList.vue'),
                    props: true,
                }
            ]
        },

        {
            path: '/usersManager',
            component: () => import('@/components/usersManager/index.vue'),
            name: 'usersListRoute',
            children: [
                {
                    path: 'disabledUsers/:user?',
                    name: 'disabledUsersRoute',
                    component: () => import('@/components/usersManager/disabledUsers.vue'),
                    props: true,
                },
                {
                    path: 'employeeReviewSessions',
                    name: 'employeeReviewSessionsRoute',
                    component: () => import('@/components/usersManager/employeeReviewSessions.vue'),
                    props: false
                },
                {
                    path: 'teams/:teamId?',
                    name: 'teamsListRoute',
                    component: () => import('@/components/usersManager/teams.vue'),
                    props: true,
                },
                {
                    path: 'locations',
                    name: 'locationsListRoute',
                    component: () => import('@/components/usersManager/locations.vue')
                },
                {
                    path: 'jobTitles',
                    name: 'jobTitlesListRoute',
                    component: () => import('@/components/usersManager/jobTitles.vue')
                },
                {
                    path: 'disabledLocations',
                    name: 'disabledLocationsListRoute',
                    component: () => import('@/components/usersManager/disabledLocations.vue')
                },
                {
                    path: 'employmentEndMotivations',
                    name: 'employmentEndMotivationsListRoute',
                    component: () => import('@/components/usersManager/employmentEndMotivations.vue')
                },
                {
                    path: 'contractSuspensionReasons',
                    name: 'contractSuspensionReasonsListRoute',
                    component: () => import('@/components/usersManager/contractSuspensionReasons.vue')
                },
                {
                    path: 'contractTypes',
                    name: 'contractTypesListRoute',
                    component: () => import('@/components/usersManager/contractTypes.vue')
                },
            ]
        },

        {
            path: '/settings',
            component: () => import('@/components/settings.vue'),
            children: [
                {
                    path: 'billing',
                    component: () => import('@/components/settings/billing.vue'),
                    name: 'billingSettings',
                },
                {
                    path: 'efactura',
                    component: () => import('@/components/settings/efactura.vue'),
                    name: 'efactura',
                },
                {
                    path: 'customFields/:subTab?',
                    component: () => import('@/components/settings/customFieldsIndex.vue'),
                    name: 'customFieldsSettings',
                    props: true
                },
                {
                    path: 'company/:subTab?',
                    component: () => import('@/components/settings/company.vue'),
                    name: 'companySettings',
                    props: true
                },
                {
                    path: 'companyFreeDays',
                    component: () => import('@/components/settings/companyFreeDays.vue')
                },
                {
                    path: 'apiKeys',
                    component: () => import('@/components/settings/apiKeys.vue')
                },
                {
                    path: 'integrations/:subTab?/:access_token?/:team_id?/:error?',
                    component: () => import('@/components/settings/integrations.vue'),
                    name: 'integrationsSettings',
                    props: true
                },
                {
                    path: 'stripeSuccess/:invoiceId?',
                    component: () => import('@/components/settings/stripeSuccess.vue'),
                    name: 'stripeSuccessRoute',
                    props: true
                },
                {
                    path: 'predefinedShifts',
                    name: 'predefinedShiftsRoute',
                    component: () => import('@/components/settings/predefinedShifts.vue')
                },
                {
                    path: 'schedulePatterns',
                    name: 'schedulePatternsRoute',
                    component: () => import('@/components/settings/schedulePatterns.vue')
                },
                {
                    path: 'tools',
                    name: 'toolsRoute',
                    component: () => import('@/components/settings/tools.vue')
                },
                {
                    path: 'rfidDevices',
                    component: () => import('@/components/settings/rfidAgents.vue')
                },
                {
                    path: 'templates',
                    component: () => import('@/components/settings/documentTemplates.vue'),
                    children: [
                        {
                            path: '',
                            name: 'documentTemplatesRoute',
                            component: () => import('@/components/settings/documentTemplates/templatesList.vue')
                        }
                    ]
                },
                {
                    path: 'series',
                    component: () => import('@/components/settings/documentSeries.vue'),
                    children: [
                        {
                            path: '',
                            name: 'documentSeriesRoute',
                            component: () => import('@/components/settings/documentSeries/seriesList.vue')
                        }
                    ]
                },
                {
                    path: 'document_folders',
                    component: () => import('@/components/settings/documentFolders.vue'),
                    children: [
                        {
                            path: '',
                            name: 'documentFoldersRoute',
                            component: () => import('@/components/settings/documentFolders/foldersList.vue')
                        }
                    ]
                },
                {
                    path: 'employeeReviews/:subTab?',
                    name: 'employeeReviewsSettingsRoute',
                    component: () => import('@/components/settings/employeeReviews.vue'),
                    props: true
                },
                {
                    path: 'eventTypes',
                    component: () => import('@/components/settings/eventTypes.vue'),
                    children: [
                        {
                            path: '',
                            name: 'eventTypesRoute',
                            component: () => import('@/components/settings/eventTypes/index.vue')
                        },
                        {
                            path: 'disabledEventTypes',
                            name: 'disabledEventTypesRoute',
                            component: () => import('@/components/settings/eventTypes/disabledEventTypes.vue')
                        },
                    ]
                },
                {
                    path: 'leaveDaysTypes',
                    name: 'leaveDaysTypesRoute',
                    component: () => import('@/components/settings/leaveDaysTypes.vue')
                },
                {
                    path: 'healthInsuranceCompanies',
                    name: 'healthInsuranceCompaniesRoute',
                    component: () => import('@/components/settings/healthInsuranceCompanies.vue'),
                },
            ]
        },

        {
            path: '/customDocumentAdd/:template_id?',
            name: 'addDocumentTemplateRoute',
            component: () => import('@/components/settings/documentTemplates/addTemplate.vue'),
            props: true
        },

        {
            path: '/customDocument/:template_id',
            name: 'editDocumentTemplateRoute',
            component: () => import('@/components/settings/documentTemplates/editTemplate.vue'),
            props: true
        },

        {
            path: '/checkout',
            component: () => import('@/components/checkout/checkout.vue'),
            name: 'checkout',
        },

        {
            path: '/checkout/edit',
            component: () => import('@/components/checkout/edit.vue'),
            name: 'checkoutEdit',
        },

        {
            path: '/checkout/op/:ID?',
            name: 'checkoutOP',
            component: () => import('@/components/checkout/op.vue'),
            props: true,
        },

        {
            path: '/checkout/mobilpay',
            name: 'checkoutMobilPay',
            component: () => import('@/components/checkout/mobilpay.vue'),
        },

        {
            path: '/moduleDisabled',
            name: 'moduleDisabled',
            component: () => import('@/components/modules/moduleDisabled.vue'),
        },

        {
            path: '/invoices/view/:ID?',
            name: 'invoiceViewRoute',
            component: () => import('@/components/invoices/invoiceView.vue'),
            props: true
        },

        // reports
        {
            path: '/reports',
            name: 'reportsRoute',
            component: () => import('@/components/reports.vue'),
            props: true,
            children: [
                {
                    path: 'paidLeave/:page?/:sortItem?/:sortOrder?/:users?/:teams?/:years?/:leaveTypes?/:employees?/:fromDate?/:upToDate?',
                    name: 'paidLeaveReportRoute',
                    component: () => import('@/components/reports/paidLeave.vue'),
                    props: true
                },
                {
                    path: 'reviews/:page?/:userBy?/:userFor?/:reviewStatus?/:teams?/:reviewTypesSelected?/:dateInterval?/:scoreLow?/:scoreHigh?/:scoreHigh2?/:sortItem?/:sortOrder?',
                    name: 'reviewsReportRoute',
                    component: () => import('@/components/reports/reviews.vue'),
                    props: true
                },
                {
                    path: 'organizationalChart/:teamIds?/:includeVirtualTeams?',
                    name: 'organizationalChartRoute',
                    component: () => import('@/components/reports/organizationalChart.vue'),
                    props: true
                },
                {
                    path: 'organizationalChartTeams/:teamIds?',
                    name: 'organizationalChartTeamsRoute',
                    component: () => import('@/components/reports/organizationalChartTeams.vue'),
                    props: true
                },
                {
                    path: 'medical/:teamIds?/:userIds?/:checkEmployeesWithMedicalDays?/:dateInterval?',
                    name: 'medicalReportRoute',
                    component: () => import('@/components/reports/medical.vue'),
                    props: true
                },
                {
                    path: 'employees/:teamIds?/:userIds?',
                    name: 'employeesReportRoute',
                    component: () => import('@/components/reports/employees.vue'),
                    props: true
                },
                {
                    path: 'vacationPlanner/:subTab?/:year?/:teamIds?/:userIds?/:eventTypeId?/:displayUserMonthTotals?',
                    name: 'vacationPlannerReportRoute',
                    component: () => import('@/components/reports/vacationPlanner.vue'),
                    props: true
                },
                {
                    path: 'customFields/:teamIds?/:userIds?',
                    name: 'customFieldsReportRoute',
                    component: () => import('@/components/reports/customFields.vue'),
                    props: true
                },
                {
                    path: 'clocking/:month?/:year?/:teamIds?/:locationIds?/:projectIds?/:userIds?/:tabId?/:projectsFolderId?/:isBillable?',
                    name: 'clockingRoute',
                    component: () => import('@/components/reports/clocking.vue'),
                    props: true
                },
                {
                    path: 'clockingAttendance/:month?/:year?/:teamIds?/:locationIds?/:projectIds?/:userIds?/:tabId?/:projectsFolderId?/:isBillable?',
                    name: 'clockingAttendanceRoute',
                    component: () => import('@/components/reports/clocking.vue'),
                    props: true
                },
                {
                    path: 'activityOverview/:startDate?/:endDate?/:teamIds?/:locationIds?/:projectIds?/:usersIds?/:projectsFolderId?/:isBillable?',
                    name: 'activityOverviewRoute',
                    component: () => import('@/components/reports/activityOverview.vue'),
                    props: true
                },
                {
                    path: 'foodCoupons/:month?/:year?/:teamIds?/:userIds?',
                    name: 'foodCouponsRoute',
                    component: () => import('@/components/reports/foodCoupons.vue'),
                    props: true
                },
                {
                    path: 'attendance/:datasource/:month?/:year?/:teamIds?/:locationIds?/:userIds?',
                    name: 'attendanceRoute',
                    component: () => import('@/components/reports/attendance.vue'),
                    props: true
                },
                {
                    path: 'attendanceDetailed/:datasource/:month?/:year?/:teamIds?/:locationIds?/:userIds?',
                    name: 'attendanceDetailedRoute',
                    component: () => import('@/components/reports/attendanceDetailed.vue'),
                    props: true
                },
                {
                    path: 'realAttendance/:page?/:users?/:teams?/:eventTypes?/:hoursStart?/:hoursEnd?/:dateInterval?/:intervalType?/:terminalType?/:locationID?/:RFIDAgentID?/:projectID?/:usersIDs?/:sortItem?/:sortOrder?/:projectsFolderId?/:isBillable?',
                    name: 'realAttendanceRoute',
                    component: () => import('@/components/reports/realAttendance.vue'),
                    props: true
                },
                {
                    path: 'workedHours/:page?/:teams?/:year?/:month?/:minWorked?/:maxWorked?/:useLeaveDays?/:sortItem?/:sortOrder?/:norm?',
                    name: 'workedHours',
                    component: () => import('@/components/reports/workedHours.vue'),
                    props: true
                },
                {
                    path: 'employeeContracts/:page?/:employeeType?/:employmentIntervalFilter?/:sortItem?/:sortOrder?/:user?/:endMotivationId?/:dateInterval?',
                    name: 'employeeContractsRoute',
                    component: () => import('@/components/reports/employeeContracts.vue'),
                    props: true
                },
                {
                    path: 'compensatoryTime/:page?/:sortItem?/:sortOrder?/:users?/:teams?/:freeDay?/:year?',
                    name: 'compensatoryTimeRoute',
                    component: () => import('@/components/reports/compensatoryTime.vue'),
                    props: true
                },
                {
                    path: 'overtime/:page?/:sortItem?/:sortOrder?/:users?/:teams?/:reason?/:hoursStart?/:hoursEnd?/:dateInterval?',
                    name: 'overtimeReportRoute',
                    component: () => import('@/components/reports/overtime.vue'),
                    props: true
                },
                {
                    path: 'files/:page?/:filename?',
                    name: 'filesReportRoute',
                    component: () => import('@/components/reports/files.vue'),
                    props: true
                },
                {
                    path: 'dataExport/:month?/:year?/:teamIds?',
                    name: 'dataExportRoute',
                    component: () => import('@/components/reports/dataExport.vue'),
                    props: true
                },
                {
                    path: 'scheduleChanges/:date?/:userId?',
                    name: 'scheduleChangesRoute',
                    component: () => import('@/components/reports/scheduleChanges.vue'),
                    props: true
                },
                {
                    path: 'overtimeCompensation/:eventTypes?/:users?/:teams?/:dateInterval?',
                    name: 'overtimeCompensationRoute',
                    component: () => import('@/components/reports/overtimeCompensation.vue'),
                    props: true
                },
                {
                    path: 'overtimeCompensationDetailed/:eventTypes?/:users?/:teams?/:compensationTypes?/:dateInterval?',
                    name: 'overtimeCompensationDetailedRoute',
                    component: () => import('@/components/reports/overtimeCompensationDetailed.vue'),
                    props: true
                },
            ]
        },

        // team info page
        {
            path: '/teamInfoPage/:teamId?/:language?',
            name: 'teamInfoPageRoute',
            component: () => import('@/components/teamInfoReport/teamInfoPage.vue'),
            props: true,
        },

        {
            path: '/teamInfoReport/:teamId?/:month?/:year?/:language?',
            name: 'teamInfoReportRoute',
            component: () => import('@/components/teamInfoReport/teamInfoReport.vue'),
            props: true,
        },

        // work schedule
        {
            path: '/workSchedule/:teams?/:userIds?/:month?/:year?/:calculationTabId?/:triggersFiltersIds?',
            name: 'workScheduleRoute',
            component: () => import('@/components/settings/workSchedule.vue'),
            props: true
        },

        // data import
        {
            path: '/importProjects',
            name: 'importProjectsRoute',
            component: () => import('@/components/usersManager/projectsImport.vue')
        },

        {
            path: '/importEmployeeReplacements',
            name: 'importEmployeeReplacementsRoute',
            component: () => import('@/components/importEmployeeReplacements.vue')
        },

        // user notifications
        {
            path: '/notifications/:isRead/:page?',
            name: 'userNotificationsRoute',
            component: () => import('@/components/userNotifications/notifications.vue'),
            props: true
        },

        // user promotions
        {
            path: '/emagPromotion',
            name: 'emagPromotionRoute',
            component: () => import('@/components/userPromotions/emagPromotion.vue'),
            props: true
        },

        {
            path: '/reminders/:status/:page?',
            name: 'userRemindersRoute',
            component: () => import('@/components/userNotifications/reminders.vue'),
            props: true
        },

        {
            path: '/comments/:threadID?',
            name: 'userCommentsRoute',
            component: () => import('@/components/userNotifications/comments.vue'),
            props: true
        },

        // importer route
        {
            path: '/importer/:endpoint?',
            name: 'importerRoute',
            component: () => import('@/components/importer/importerIndex.vue'),
            props: true
        },

        // projects
        {
            path: '/projects/:filter?',
            name: 'projects',
            component: () => import('@/components/projects/index.vue'),
            props: true,
            children: [
                {
                    path: 'edit/:projectId/:parentFilter?',
                    name: 'projectEdit',
                    component: () => import('@/components/projects/components/edit.vue'),
                    props: true,
                },
            ],
        },

        // projects templates
        {
            path: '/projectsTemplates/:filter?',
            name: 'projectsTemplates',
            component: () => import('@/components/projects/index.vue'),
            props: true,
            children: [
                {
                    path: 'edit/:projectId/:parentFilter?',
                    name: 'projectTemplateEdit',
                    component: () => import('@/components/projects/components/edit.vue'),
                    props: true,
                },
            ],
        },

        // reviews viewer
        {
            path: '/reviewsViewer/:reviewInstances?/:instance?/:sessions?/:field?/:tab?/',
            name: 'reviewsViewerRoute',
            component: () => import('@/components/reviewsViewer.vue'),
            props: true
        },

        // premium iflow modules
        {
            path: '/premiumModules',
            name: 'premiumModulesRoute',
            component: () => import('@/components/premiumModules/premiumModules.vue'),
            props: true
        },

        // new dashboard Rfid
        {
            path: '/dashboardIflowRfid/:accessToken?/:rfidTag?/:language?',
            name: 'dashboardIflowRfid',
            component: () => import('@/components/dashboardRfid/index.vue'),
            props: true,
            children: [
                {
                    path: 'myProfile/:page?/:isRead?',
                    name: 'myProfile',
                    component: () => import('@/components/dashboardRfid/components/myProfile.vue'),
                    props: true,
                },
                {
                    path: 'addEvent',
                    name: 'addEvent',
                    component: () => import('@/components/dashboardRfid/components/addEvent.vue'),
                    props: true
                },
                {
                    path: 'myActivity/:page?',
                    name: 'myActivity',
                    component: () => import('@/components/dashboardRfid/components/myActivity.vue'),
                    props: true
                },
                {
                    path: 'myAttendance/:page?',
                    name: 'myAttendance',
                    component: () => import('@/components/dashboardRfid/components/myAttendance.vue'),
                    props: true
                },
            ]
        },

        // mobile app one button check in and out
        {
            path: '/mobile',
            name: 'mobileRoute',
            component: () => import('@/components/mobileApp/index.vue'),
            props: true,
            children: [
                {
                    path: 'dashboardMobile',
                    name: 'dashboardMobileRoute',
                    component: () => import('@/components/mobileApp/dashboardMobile.vue'),
                    props: true
                },
            ]
        },

        // 404
        {
            path: '/404',
            name: '404Route',
            component: () => import('@/components/404.vue')
        },

        {
            path: '',
            redirect: { name: 'dashboardRoute' }
        },

        {
            path: '*',
            redirect: { name: '404Route' }
        },
    ],

    scrollBehavior(to, from, savedPosition) {
        //return { x: 0, y: 0 };
        if (savedPosition) {
            //Returning the savedPosition will result in a native-like behavior when navigating with back/forward buttons
            return savedPosition;
        } else {
            if (('projects' === from.name || 'projectEdit' === from.name) && ('projects' === to.name || 'projectEdit' === to.name)) {
                return;
            }
            if (
                (to.path.includes('/activity') && from.path.includes('/activity')) ||
                (to.path.includes('/workSchedule') && from.path.includes('/workSchedule')) ||
                (to.path.includes('/dashboard') && from.path.includes('/dashboard')) ||
                (to.path.includes('/clocking') && (from.path.includes('/clocking') || from.path.includes('/clockingAttendance'))) ||
                (to.path.includes('/clockingAttendance') && (from.path.includes('/clocking') || from.path.includes('/clockingAttendance')))
            ) {
                // do not scroll to top on activity route when using filters
            } else {
                //scroll to top on new routes
                return { x: 0, y: 0 };
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js